//@libs
import PropTypes from "prop-types";
//@mui-material
import GetAppIcon from "@material-ui/icons/GetApp";
//import FilePresentIcon from '@mui/icons-material/FilePresent';
//@components
import IconButton from "./";

const DetailsIconButton = ({
  title = "Solicitud",
  icon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={icon || <GetAppIcon />}
      {...props}
    />
  );
};

DetailsIconButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default DetailsIconButton;
